/* ConfigureAuditScreenComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ConfigureAuditScreenRenderer");
const ScheduleVeilComponent = require("../../../../lib/actions/veils/schedule/ScheduleVeilComponent");
const Registrations = require("../../../../../RegistrationNamespaces");
const _ = require("lodash");

class ConfigureAuditScreenComponent extends EventEmitter {
    constructor(
        logger,
        GameEditor,
        ConfigAuditPolicy,
        DeviceEntity,
        ActiveView,
        modalUserFeedback,
        userSession
    ) {
        super();
        this._logger = logger;
        this._gameEditor = GameEditor;
        this._configAuditPolicy = ConfigAuditPolicy;
        this._deviceEntity = DeviceEntity;
        this._activeView = ActiveView;
        this._modalUserFeedback = modalUserFeedback;

        this._userSession = userSession;
        this._workId = undefined;
        this._labelValues = undefined;
        this._isCaptureSnapshotActive = false;
        this._runPermLevels = ["auditRunLevel1", "auditRunLevel2", "auditRunLevel3"];
        this._hasBasicSearch = !_.isEmpty(
            _.get(this._activeView._userGridData.getBasicSearchData(), "filterQuery", {})
        );
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
                this._isCaptureSnapshotActive = undefined;
                this._workId = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "ConfigureAuditScreenComponent.shutdown() error.");
            }
        );
    }

    get isCaptureSnapshotActive() {
        return this._isCaptureSnapshotActive;
    }

    set isCaptureSnapshotActive(value) {
        this.setIsCaptureSnapshotActive(value);
    }

    setIsCaptureSnapshotActive(value) {
        this._isCaptureSnapshotActive = String(value) === "true";
    }

    whenModelIsReady() {
        // return this._configAuditPolicy
        //     .loadLabelValues(this._userSession.activeOrganization.id)
        //     .then((labelValues) => {
        //         this._availableAuditRunPerms = [];
        //         this._labelValues = labelValues;
        //         return Promise.resolve();
        //     });
        return this._configAuditPolicy
            .loadConfigAuditPolicies(
                this._userSession.activeOrganization.id,
                {rules: {$exists: true, $type: "array", $ne: []}},
                {_id: false, id: true, name: true, permissionLevel: true},
                {name: 1}
            )
            .then((policies) => {
                const availablePermLvls = this._runPermLevels.reduce((acc, lvl) => {
                    if (this._userSession.authorizedActions.indexOf(lvl) >= 0) {
                        acc.push(lvl);
                    }
                    return acc;
                }, []);

                this._labelValues = policies
                    .filter((policy) => {
                        const permLevel = "auditRunLevel" + policy.permissionLevel.substr(-1);
                        // console.log(policy);
                        if (availablePermLvls.indexOf(permLevel) >= 0) {
                            return true;
                        }
                        return false;
                    })
                    .map((policy) => {
                        return {label: policy.name, value: policy.id};
                    });

                return Promise.resolve();
            });
    }

    cancelAction(err) {
        this._context.reject(err);
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _scheduleConfigAuditWork(selection, workInput) {
        if (typeof workInput.policyId === "undefined") {
            this._logger.warn(
                {error: {errorMsg: "Required Audit Policy not selected."}},
                "ConfigureAuditScreenComponent._startConfigAuditWork() - Error"
            );
            return this._modalUserFeedback.displayError({
                errorMsg: "Required Audit Policy not selected.",
                errorCode: "ValidationError",
            });
        }
        // let workTarget = this._getWorkTarget(selection);

        return this._getWorkTarget(selection).then((workTarget) => {
            return this._modalUserFeedback
                .displayCustom(
                    new ScheduleVeilComponent(this._logger, true, "Audit - Schedule", {
                        workType: "audit",
                        firstTime: true,
                    }),
                    {
                        dontHide: false,
                    }
                )
                .then((scheduleDef) => {
                    let schedule = scheduleDef.schedule;
                    let name = workInput.auditTitle;
                    let policyName = this._labelValues.find(
                        (selectedObj) => selectedObj.value === workInput.policyId
                    );
                    let description = policyName ? "Policy: " + policyName.label : "";
                    let displayName = name
                        ? name
                        : "Audit Run - " +
                          new Date().toLocaleDateString() +
                          " " +
                          new Date().toLocaleTimeString();
                    let workInputSchedule = Object.assign(workInput, scheduleDef.workInput);
                    workInputSchedule.description = displayName;
                    return this._deviceEntity.scheduleAuditWork(
                        this._userSession.activeOrganization.id,
                        displayName,
                        description,
                        schedule,
                        workTarget,
                        workInputSchedule
                    );
                })
                .catch((err) => {
                    if (!err.userRejected) {
                        if (this._logger) {
                            this._logger.warn(
                                {
                                    error: err,
                                },
                                "ConfigureAuditScreenComponent._scheduleConfigAuditWork() - Error"
                            );
                        } else {
                            console.error(err);
                        }
                        return this._modalUserFeedback.displayError(err);
                    }
                });
        });
    }

    _startConfigAuditWork(selection, workInput) {
        // let workTarget = this._getWorkTarget(selection);
        this._getWorkTarget(selection).then((workTarget) => {
            if (typeof workInput.policyId === "undefined") {
                this._logger.warn(
                    {error: {errorMsg: "Required Audit Policy not selected."}},
                    "ConfigureAuditScreenComponent._startConfigAuditWork() - Error"
                );
                return this._modalUserFeedback.displayError({
                    errorMsg: "Required Audit Policy not selected.",
                    errorCode: "ValidationError",
                });
            }
            /**
             *
             * @param {Object} progress - progress data object
             * @param {number} progress.startTime
             * @param {number} progress.targetCount
             * @param {number} progress.successCount
             * @param {number} progress.failureCount
             * @param {string} progress.policyId
             * @param {string} progress.policyName
             * @param {string} progress.policyDescription
             */
            let aborted = false;

            const progressCB = ({workId, successCount, failureCount, targetCount}) => {
                if (workId) {
                    this._workId = workId;
                }
                let msg = `Completed ${successCount}, error ${failureCount} of ${targetCount} devices`;
                this._modalUserFeedback.showLoadingProgress(msg);
            };

            this._modalUserFeedback.displayLoading({
                message: "Auditing your devices...",
                showHideButton: true,
                showAbortButton: true,
                onAbort: () => {
                    aborted = true;
                    this._abortAuditWork();
                },
            });

            return this._configAuditPolicy
                .runAuditWork(
                    this._userSession.activeOrganization.id,
                    workTarget,
                    workInput,
                    {launchAndForget: false},
                    progressCB
                )
                .then((result) => {
                    if (aborted) {
                        return;
                    }
                    if (result.errorMsg) {
                        let err = new Error(result.errorMsg);
                        err.errorCode = "ConfigAuditError";
                        err.errorMsg = result.errorMsg;
                        throw err;
                    }
                    if (!this._modalUserFeedback.isStillOpen) {
                        return;
                    }
                    let userNotificationMessage = "";
                    if (!result.summary) {
                        userNotificationMessage = `Total number of devices: ${
                            result._trimmed.targetResults || 0
                        }`;
                    } else {
                        const {
                            deviceCount,
                            deviceSuccessCount,
                            deviceErrorCount,
                            devicesInViolationCount,
                            violationCount,
                            devicesSkippedCount,
                        } = result.summary;
                        userNotificationMessage = [
                            `Total devices: ${deviceCount || 0}`,
                            `Audited devices: ${deviceSuccessCount || 0}`,
                            `Skipped Devices:${devicesSkippedCount}` || 0,
                            `Device errors: ${deviceErrorCount || 0}`,
                            "",
                            `Devices in violation: ${devicesInViolationCount || 0}`,
                            `Total violations: ${violationCount || 0}`,
                        ].join("\r\n");
                    }

                    return this._modalUserFeedback
                        .displayConfirmation(userNotificationMessage, {
                            title: "Audit Completed",
                            confirmDetails: {
                                text: "View Results",
                                type: "additive",
                            },
                            rejectDetails: {
                                text: "OK",
                                type: "text",
                            },
                        })
                        .then(() => {
                            if (result.summary && result.summary.policyId) {
                                this._gameEditor._LMRBLayout.emit("ViewAuditResults");
                                return this._gameEditor.launchAuditEditor(
                                    {
                                        fqn: Registrations.AUDIT_POLICY_EDITOR_VIEW_RESULTS,
                                    },
                                    {
                                        id: result.summary.policyId,
                                        title: _.get(result.summary, "policyName", ""),
                                    }
                                );
                            } else {
                                this._logger.warn(
                                    {error: {}},
                                    "ConfigureAuditScreenComponent._startConfigAuditWork() - No policyId received"
                                );
                                return Promise.reject();
                            }
                        });
                })
                .catch((err) => {
                    if (aborted) {
                        return;
                    }
                    if (err && err.closed) {
                        this._modalUserFeedback.hideDisplayed();
                        return Promise.resolve();
                    }
                    if (err && !err.userRejected) {
                        if (this._logger) {
                            this._logger.warn(
                                {error: err},
                                "ConfigureAuditScreenComponent._startConfigAuditWork() - Error"
                            );
                        } else {
                            console.error(err);
                        }
                        return this._modalUserFeedback.displayError(err);
                    }
                });
        });
    }

    _abortAuditWork() {
        this._configAuditPolicy.cancelWork(this._userSession._activeOrganization.id, this._workId);
        const title = "Audit Aborted";
        const msg = "Audit aborted by user";
        return this._modalUserFeedback.displayNotification(msg, {title});
    }
    /**
     * Create workTarget Object from devices component selection
     * @param {String} selection
     * @returns {Object}
     */
    _getWorkTarget(selection) {
        return Promise.resolve().then(() => {
            let query;
            if (selection === "all") {
                return {
                    entityType: "Device",
                    category: "entity",
                    method: "query",
                    query: {},
                };
            }
            if (selection === "selection") {
                return {
                    category: "entity",
                    entityType: "Device",
                    method: "multi",
                    ids: this._activeView.getSelectedDeviceIds().selectedRows,
                };
            }
            if (selection === "apply_current_filter") {
                query = this._activeView._userGridData.getAdvancedSearchData();
                return {
                    entityType: "Device",
                    category: "entity",
                    method: "query",
                    query,
                };
            }
            if (selection === "current_search_results") {
                return this._activeView._DeviceEntityDef
                    .loadDevices(
                        this._activeView._gameEditor._activeOrgId,
                        _.get(
                            this._activeView._userGridData.getBasicSearchData(),
                            "filterQuery",
                            {}
                        ),
                        {id: true}
                    )
                    .then((deviceIds) => {
                        let ids = deviceIds.map((device) => device.id);
                        return {
                            category: "entity",
                            entityType: "Device",
                            method: "multi",
                            ids,
                        };
                    });
            }
            return {};
        });
    }
    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ConfigureAuditScreenComponent;
